import { render, staticRenderFns } from "./ReleaseUpdate.vue?vue&type=template&id=34bae207&scoped=true&"
import script from "./ReleaseUpdate.vue?vue&type=script&lang=js&"
export * from "./ReleaseUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseUpdate.vue?vue&type=style&index=0&id=34bae207&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bae207",
  null
  
)

export default component.exports